import { Card, Layout, QRCode, Row, Typography } from 'antd';
import Sider from 'antd/es/layout/Sider';
import Box from 'components/Box';
import Button from 'components/Button';
import Modal from 'components/Modal';
import Text from 'components/Text';
import Sidebar from 'components/layout/Sidebar';
import colorTheme from 'constants/color';
import { DATE_FORMAT } from 'features/appointment/utils/format';
import { IconStore, IconWeb } from 'features/giftCards/components/Icons';
import TableGiftCardDetail from 'features/giftCards/components/TableGiftCardDetail';
import giftCardsActions from 'features/giftCards/services/actions';
import giftCardsSelectors from 'features/giftCards/services/selectors';
import moment from 'moment';
import { FC, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import shopSelectors from 'services/shop/selectors';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';
import { formatPhone } from 'utils/formatPhone';
import GiftCardDetailV2 from './v2';
const { Paragraph } = Typography;


interface IGiftCardDetail {

}
// const GIFT_CARD_DETAIL = 'GIFT_CARD_DETAIL';
const GiftCardDetail: FC<IGiftCardDetail> = () => {
    const [visibleConfirm, setVisibleConfirm] = useState(false);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { gift_card_id = '' } = useParams();
    const giftCardDetail = giftCardsSelectors.getGiftCardDetail();
    const resetGiftCardStatus = giftCardsSelectors.getResetTimeGiftCardStatus();
    const versionUI = shopSelectors.data.versionUI();
    const fetchData = () => {
        dispatch(giftCardsActions.getGiftCardDetail.fetch({ id: gift_card_id }));
    };
    // const dataAppointment = giftCardsSelectors.getParams()?.[GIFT_CARD_DETAIL];
    // useEffect(() => {
    //     dispatch(giftCardsActions.setParams({
    //         [GIFT_CARD_DETAIL]: {
    //             startTime: dataAppointment?.startTime || moment().format(DATE_FORMAT),
    //             endTime: dataAppointment?.endTime || moment().format(DATE_FORMAT)
    //         }
    //     }));
    // }, []);
    useEffect(() => {
        fetchData();
    }, [gift_card_id]);

    useEffect(() => {
        if (resetGiftCardStatus) {
            fetchData();
            dispatch(giftCardsActions.resetGiftCardDetail.fail(false));
        }
    }, [resetGiftCardStatus]);

    const onBack = () => {
        navigate(-1);
    };

    const handleReset = () => setVisibleConfirm(true);

    const handleConfirmReset = () => {
        setVisibleConfirm(false);
        dispatch(giftCardsActions.resetGiftCardDetail.fetch([gift_card_id]));
    };

    if (versionUI === 'V2') {
        return (
            <>
                <GiftCardsStyled>
                    <Sidebar />
                    <GiftCardDetailV2
                        detail={giftCardDetail}
                        onReset={handleReset}
                    />
                </GiftCardsStyled>
                <Modal
                    visible={visibleConfirm}
                    onClose={() => setVisibleConfirm(false)}
                    hiddenHeader
                    v2
                    okTitle={'Reset'}
                    onSubmit={handleConfirmReset}
                    className='modal-non-opacity modal-bg-v2'
                >
                    <ModalStyled>
                        <IconWarningBig />
                        <Text variant='H7' mt={2} mb={1} style={{ fontSize: 24 }} >
                            Do you want to reset gift card?
                        </Text>
                    </ModalStyled>
                </Modal>
            </>
        );
    }

    return (
        <GiftCardDetailStyled>
            <Sidebar />
            <LeftSide width={500}>
                <HeaderBox>
                    <HeaderBox>
                        <Box display='flex' flexDirection='row' alignItems='center'>
                            <Button icon="back" ntype="SECONDARY" onClick={onBack} />
                            <Text variant="H5" pl={2}>Gift Card</Text>
                        </Box>
                        <Button icon="change" ntype='PRIMARY' onClick={handleReset}>
                            Reset
                        </Button>
                    </HeaderBox>
                </HeaderBox>
                <Box p='4'>
                    <Card>
                        <Box display='flex' flexDirection='column' alignItems='center'>
                            <QRCode bordered={false} size={85} value={giftCardDetail?.giftCard?.giftCode || ''} />
                            <Paragraph copyable >{giftCardDetail?.giftCard?.giftCode || ''}</Paragraph>
                        </Box>
                        <CardContent>
                            <Text variant='BODY_2'>Amount</Text>
                            <TextBox mb='1'><Text variant='BODY_2'>{formatCurrency(giftCardDetail?.giftCard?.amount)}</Text></TextBox>
                            <Text variant='BODY_2'>Redeemed</Text>
                            <TextBox mb='1'><Text variant='BODY_2'>{formatCurrency(giftCardDetail?.giftCard?.usedAmount)}</Text></TextBox>
                            <Text variant='BODY_2'>Balance</Text>
                            <TextBox mb='1'><Text variant='BODY_2'>{formatCurrency(giftCardDetail?.giftCard?.amount - giftCardDetail?.giftCard?.usedAmount)}</Text></TextBox>
                            <Text variant='BODY_2'>Expiration</Text>
                            <TextBox mb='1'><Text variant='BODY_2'>{moment(giftCardDetail?.giftCard?.expireDate).format(DATE_FORMAT)}</Text></TextBox>
                            <Text variant='BODY_2'>Customer</Text>
                            <TextBox mb='1'><Text variant='BODY_2'>{giftCardDetail?.giftCard?.customerName} {formatPhone(giftCardDetail?.giftCard?.customerPhone ?? '')}</Text></TextBox>
                            <Text variant='BODY_2'>Staff</Text>
                            <TextBox mb='1'><Text variant='BODY_2'>{giftCardDetail?.giftCard?.staffName}</Text></TextBox>
                            <Text variant='BODY_2'>Status</Text>
                            <TextBox mb='1'><Text variant='BODY_2'>
                                <Row align={'middle'} style={{ gap: '5px' }} justify={'center'}>
                                    {giftCardDetail?.giftCard?.status ? <IconWeb /> : <IconStore />}
                                    <Text variant='BODY_2'>{giftCardDetail?.giftCard?.status ? 'Online' : 'In Store'}</Text>
                                </Row>
                            </Text></TextBox>
                            <Text variant='BODY_2'>Reset Time</Text>
                            <TextBox mb='1'><Text variant='BODY_2'>{giftCardDetail?.giftCard?.numberReused}</Text></TextBox>
                        </CardContent>
                    </Card>
                </Box>
            </LeftSide>
            <RightSide>
                <HeaderBox>
                    <Text variant="H5">History Gift Card</Text>
                    {/* <Box pt='2' display='flex' flexDirection='row' alignItems='center' gap='1'>
                        <AppointmentDatePicker size='middle' actions={giftCardsActions} selectors={giftCardsSelectors} type={GIFT_CARD_DETAIL} />
                        <SwitchCalendarType actions={giftCardsActions} selectors={giftCardsSelectors} type={GIFT_CARD_DETAIL} />
                    </Box> */}
                </HeaderBox>
                <TableGiftCardDetail data={giftCardDetail?.historyTracking} />
            </RightSide>
            <Modal
                visible={visibleConfirm}
                onClose={() => setVisibleConfirm(false)}
                hiddenHeader
                okTitle={'Reset'}
                onSubmit={handleConfirmReset}
            >
                <ModalStyled>
                    <IconWarningBig />
                    <Text variant='H7' mt={2} mb={1} >
                        Do you want to reset this gift card?
                    </Text>
                </ModalStyled>
            </Modal>
        </GiftCardDetailStyled>
    );
};

export default GiftCardDetail;
const GiftCardsStyled = styled(Layout)` 
    min-height: 100vh;
    background: #F6F7FC;
`;
const GiftCardDetailStyled = styled(Layout)`
`;

const ModalStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const LeftSide = styled(Sider)`
    background-color: #D9D9D9 !important;
    padding: 1.5rem 0;
`;
const CardContent = styled(Box)`
    display: flex;
    flex-direction: column;
    background-color: #FFF1F6;
    border-radius:20px;
    padding: 20px;
`;
const TextBox = styled(Box)`
    background-color: #FFF;
    text-align: center;
    padding: 0.25rem;
    height: 1.825rem;
`;
const RightSide = styled(Layout)`
    background-color: ${colorTheme.fill_3};
    padding: 1.5rem 0;
`;
const HeaderBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
  padding: 0 1rem;
`;

const IconWarningBig = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="97" height="96" viewBox="0 0 97 96" fill="none">
        <path d="M47.1016 0.0228096C55.1129 -0.22689 63.1789 1.57766 70.3131 5.23293C80.7502 10.506 89.0973 19.7575 93.2729 30.6813C96.9722 40.1783 97.5136 50.865 94.7963 60.6872C92.5469 68.9693 88.0082 76.6156 81.8203 82.5622C75.9639 88.2318 68.624 92.355 60.7385 94.4198C51.8584 96.7699 42.2985 96.4971 33.5758 93.6119C23.9194 90.4917 15.3351 84.1821 9.45146 75.9147C5.22546 70.0184 2.37175 63.1465 1.17361 55.9933C-0.943594 43.7496 1.96467 30.7359 9.10944 20.5716C14.9679 12.1091 23.6382 5.6421 33.4163 2.43168C37.8291 0.975446 42.4538 0.14661 47.1016 0.0228096ZM46.4909 13.7206C44.5878 14.1676 42.8441 15.2692 41.6312 16.803C40.2296 18.5363 39.556 20.8171 39.7428 23.0329C40.6178 34.8842 41.4991 46.7355 42.3741 58.5868C42.4223 59.0841 42.4013 59.5982 42.544 60.085C42.7161 60.5299 43.2155 60.7292 43.6687 60.6914C46.961 60.683 50.2532 60.6998 53.5434 60.683C54.1393 60.7124 54.5883 60.1459 54.5611 59.5793C55.4654 47.3294 56.3824 35.0794 57.2784 22.8294C57.4756 19.9694 56.1642 17.0632 53.8833 15.3237C51.827 13.7122 49.0299 13.1121 46.4909 13.7206ZM46.7218 68.2957C45.2278 68.6671 43.868 69.5316 42.8923 70.7193C40.7521 73.2268 40.6933 77.2031 42.7601 79.7714C44.7682 82.4594 48.7319 83.3679 51.7095 81.8215C54.9493 80.2939 56.6027 76.1812 55.2955 72.8386C54.133 69.433 50.1945 67.3389 46.7218 68.2957Z" fill="#FFDC7C" />
    </svg>
);
